import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { BadgeCheckIcon, MapPinIcon, StarIcon } from 'lucide-react';
interface Notification {
  firstName: string;
  lastName: string;
  province: string;
}
const NOTIFICATIONS: Notification[] = [{
  firstName: 'Carlos',
  lastName: 'Méndez',
  province: 'Buenos Aires'
}, {
  firstName: 'Roberto',
  lastName: 'García',
  province: 'Córdoba'
}, {
  firstName: 'Miguel',
  lastName: 'Torres',
  province: 'Rosario'
}, {
  firstName: 'Fernando',
  lastName: 'López',
  province: 'Mendoza'
}, {
  firstName: 'Alejandro',
  lastName: 'Ruiz',
  province: 'Tucumán'
}, {
  firstName: 'Pablo',
  lastName: 'Sánchez',
  province: 'Santa Fe'
}, {
  firstName: 'Gustavo',
  lastName: 'Díaz',
  province: 'La Plata'
}, {
  firstName: 'Martín',
  lastName: 'Fernández',
  province: 'Salta'
}, {
  firstName: 'Ricardo',
  lastName: 'Pérez',
  province: 'Neuquén'
}, {
  firstName: 'Jorge',
  lastName: 'Martínez',
  province: 'Chaco'
}];
export function SocialProofPopup() {
  const [currentNotification, setCurrentNotification] = useState<Notification | null>(null);
  useEffect(() => {
    const initialTimeout = setTimeout(() => {
      showRandomNotification();
    }, 5000);
    return () => clearTimeout(initialTimeout);
  }, []);
  const showRandomNotification = () => {
    const randomIdx = Math.floor(Math.random() * NOTIFICATIONS.length);
    setCurrentNotification(NOTIFICATIONS[randomIdx]);
    setTimeout(() => {
      setCurrentNotification(null);
      const nextDelay = Math.floor(Math.random() * 3000) + 5000;
      setTimeout(showRandomNotification, nextDelay);
    }, 4000);
  };
  return <AnimatePresence data-id="element-362">
      {currentNotification && <motion.div initial={{
      opacity: 0,
      y: 30,
      scale: 0.95
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.95
    }} transition={{
      type: 'spring',
      stiffness: 400,
      damping: 25
    }} className="fixed bottom-4 left-4 z-50 bg-[#1a1a1a]/95 backdrop-blur-md rounded-lg shadow-[0_8px_32px_rgba(0,0,0,0.5)] border border-[#2a2a2a] p-3 pr-5 max-w-[280px] font-['Barlow']" data-id="element-363">
          <div className="absolute -top-2 -right-2 flex items-center gap-1 bg-[#f5a623] text-[#0a0a0a] text-[10px] font-['Barlow_Condensed'] font-extrabold px-2 py-0.5 rounded-sm shadow-md uppercase tracking-[0.05em]" data-id="element-364">
            <BadgeCheckIcon className="w-3 h-3" data-id="element-365" />
            <span data-id="element-366">Verificado</span>
          </div>

          <div className="flex items-center gap-3" data-id="element-367">
            <div className="w-10 h-10 rounded-full bg-gradient-to-br from-[#c47d0e] to-[#f5a623] flex items-center justify-center text-[#0a0a0a] text-sm font-['Bebas_Neue'] flex-shrink-0 shadow-sm" data-id="element-368">
              {currentNotification.firstName[0]}
              {currentNotification.lastName[0]}
            </div>

            <div className="min-w-0" data-id="element-369">
              <p className="text-[15px] font-bold text-[#f5f0e8] leading-tight truncate" data-id="element-370">
                {currentNotification.firstName} {currentNotification.lastName}
              </p>

              <div className="flex items-center gap-2 mt-1" data-id="element-371">
                <span className="flex items-center gap-px" data-id="element-372">
                  {[1, 2, 3, 4, 5].map(s => <StarIcon key={s} className="w-3 h-3 text-[#f5a623] fill-[#f5a623]" data-id="element-373" />)}
                </span>
                <span className="flex items-center gap-0.5 text-[11px] text-[#888888] font-semibold leading-tight uppercase tracking-wider" data-id="element-374">
                  <MapPinIcon className="w-3 h-3 flex-shrink-0" data-id="element-375" />
                  {currentNotification.province}
                </span>
              </div>

              <p className="text-[12px] text-[#e8e0d0] leading-tight mt-1.5 font-medium" data-id="element-376">
                Compró el Mega Pack Maestro Cerrajero
              </p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}